import React, { useEffect, useState } from 'react';
import './ChangesRequests.scss';
import e from 'cors';
import ApiHelper from '../../helpers/ApiHelper';
import GlobalParams from '../../helpers/GlobalParams';
import DataGrid, { Column } from 'devextreme-react/cjs/data-grid';
import { Button, LoadPanel } from 'devextreme-react';
import notify from 'devextreme/ui/notify';


const ChangesRequests = () => {

  const [endorsementsData, setEndorsementsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchChangeRequests = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-endorsement-requests?scheme_id=' + scheme_id,
        GlobalParams.bearerToken
      );
      //setEndorsementsData(result.data);
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      return [];
    }
  };

  //TODO - Fetch client schemes


  /*useEffect(() => {
    const fetchData = async () => {
      const tmpSchemesStore = GlobalParams.schemeStore;
      let tmp_endorsementsStore = [];
      setIsLoading(true);
      for (const item of tmpSchemesStore) {
        if (item.StatusCode === "001" && item.End_date !== undefined && item.End_date !== '' && item.End_date !== null) {
          const scheme_id = item.schemeID;
          const endorsementsForScheme = await fetchChangeRequests(scheme_id);
          tmp_endorsementsStore.push(...endorsementsForScheme);
        }
      }

      setIsLoading(false);
      setEndorsementsData(tmp_endorsementsStore);
    };

    fetchData();
  }, [endorsementsData]);*/ // Make sure to adjust the dependency array if needed

  useEffect(() => {
    const fetchData = async () => {
      const tmpSchemesStore = GlobalParams.schemeStore;
      let tmp_endorsementsStore = [];
      setIsLoading(true);
      for (const item of tmpSchemesStore) {
        if (item.StatusCode === "001" && item.End_date !== undefined && item.End_date !== '' && item.End_date !== null) {
          const scheme_id = item.schemeID;
          const endorsementsForScheme = await fetchChangeRequests(scheme_id);
          tmp_endorsementsStore.push(...endorsementsForScheme);
        }
      }

      setIsLoading(false);
      setEndorsementsData(tmp_endorsementsStore);
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs only once after the initial render



  return (
    <div>
      {isLoading && <LoadPanel visible={true} />}
      <DataGrid
        dataSource={endorsementsData}
        wordWrapEnabled={true}
        //columns={endorsementsColumns}
        grouping={
          {
            autoExpandAll: false
          }
        }
        summary={
          {
            groupItems: [
              {
                column: 'MemberNo',
                summaryType: 'count',
                showInGroupFooter: false
              }
            ]
          }
        }
      >
        <Column dataField="scheme_id" visible={false}></Column>
        <Column dataField="policy_number" caption='Scheme Number' groupIndex={0} ></Column>
        <Column dataField="EndorsementType" groupIndex={1}></Column>
        <Column dataField="Member" visible={false}></Column>
        <Column dataField="MemberName"></Column>
        <Column dataField="MemberAge" caption='Age' visible={false}></Column>
        <Column dataField="MemberNo" caption='Staff No' visible={false}></Column>

        <Column dataField="bulk_upload" dataType='boolean' visible={false}></Column>
        <Column dataField="file_name" visible={false}></Column>
        <Column dataField="file_url" visible={false}></Column>
        <Column dataField="SupportFileName" caption='attachement'></Column>
        <Column dataField="CreatedOn" caption="Effective Date" dataType='date' ></Column>
        <Column dataField="Status"></Column>

        <Column dataField="MemberSalary" caption='Salary' visible={false} ></Column>
        <Column dataField="IdType" visible={false}></Column>
        <Column dataField="IdNumber" visible={false}></Column>
        <Column dataField="HasDependants" dataType='boolean' visible={false}></Column>
        <Column dataField="EndorsementRequest" visible={false}></Column>
        <Column cellRender={(cellInfo) => {
          return (
            <div>
              <Button
                text=""
                type='danger'
                icon='attach'
                onClick={
                  () => {
                    if (cellInfo.data.SupportFileName !== undefined &&
                      cellInfo.data.SupportFileName !== '' &&
                      cellInfo.data.SupportFileName !== null) {
                      //download the file
                      let filename = cellInfo.data.SupportFileName;
                      console.log(filename);
                      const anchor = document.createElement('a');
                      anchor.href = GlobalParams.SupportFileUrl + filename;
                      anchor.download = filename; // Set the filename for download
                      anchor.click();
                    } else {
                      notify('No attachment found', 'error', 4000);
                    }
                  }
                }
              />
            </div>
          );
        }}></Column>
      </DataGrid>

    </div>
  );
}
export default ChangesRequests;